import { Pages } from '@/data/enums';
import { useRoute } from '@/data/hooks';
import { NS_HEADER } from '@/i18n/namespaces';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { LanguageSwitcher } from '../common';

type HeaderProps = {
  title: string;
};

export const Header = ({ title }: HeaderProps) => {
  const { step, entity } = useRoute();
  const isFirstAndPaymentPage = step === (Pages.Quotation || Pages.Payment);
  const { t } = useTranslation(NS_HEADER, {
    keyPrefix: 'logo',
  });
  return (
    <nav
      className={twMerge(
        'flex h-20 items-center p-4 shadow-header',
        !isFirstAndPaymentPage && 'hidden md:flex',
      )}
    >
      <div className="container mx-auto flex items-center justify-between">
        <img src={t(entity)} />
        <div className="hidden text-left text-xl font-bold md:block">
          {title}
        </div>
        <LanguageSwitcher />
      </div>
    </nav>
  );
};
